import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { containerPaddingL } from 'common/styles/variables';
import { getColors } from 'common/entities/color/selectors';
import { getFonts } from 'common/entities/font/selectors';

import { DISABLED_MESSAGE } from '../../constants/formStyleLabels';

const DisabledMessageContainer = styled.div`
    padding: ${containerPaddingL};
    text-align: center;
`;

// View with the disabled messaging.
const FormStylingDisabled = () => <DisabledMessageContainer>{DISABLED_MESSAGE}</DisabledMessageContainer>;

// Wrapper that decides if the disabled messaging should show.
const FormStylingDisabledWrapper = ({ isFormStylingDisabled, children }) =>
    isFormStylingDisabled ? <FormStylingDisabled /> : children;

FormStylingDisabledWrapper.propTypes = {
    isFormStylingDisabled: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
};

const mapStateToProps = (state) => ({
    isFormStylingDisabled: !getFonts(state).length || !getColors(state).length,
});

export default connect(mapStateToProps, {})(FormStylingDisabledWrapper);
